// The Mixtape Memories icon mark — "Diagonal Two-Tone Cassette" — lifted verbatim
// from Figma "05 · Assets / Icon-Light" (node 12:6), the same file committed at
// client/public/brand/mixtape-memories-icon.svg. The cassette body is split by one
// diagonal coral cut; the two reels are paper discs left against ink. Side A is the
// photos, Side B is the music — the diagonal is where they meet.
//
// The icon is drawn in a 328x328 box; the artwork itself spans x 19..309, y 69..252,
// so consumers crop to ICON_VIEWBOX for a tight fit. brandIconPath.test.js fails if
// this drifts from the committed Figma export or from the favicon.
export const ICON_VIEWBOX = '19 69 290 183';

// Colours come from the Figma primitives; `tone` picks the light (ink on paper) or
// dark (paper on ink) colourway exactly as Figma's Icon-Light / Icon-Dark do. The
// coral cut is the same in both.
export const ICON_TONES = {
  light: { line: '#241A12', reel: '#FFF9EF' },
  dark: { line: '#FFF9EF', reel: '#241A12' },
};
export const ICON_CORAL = '#E15B3B';

export const BRAND_ICON_PATHS = {
  body: 'M278.885 77.5901H49.215C37.1347 77.5901 27.3417 86.8536 27.3417 98.2808V222.425C27.3417 233.852 37.1347 243.116 49.215 243.116H278.885C290.965 243.116 300.758 233.852 300.758 222.425V98.2808C300.758 86.8536 290.965 77.5901 278.885 77.5901Z',
  cut: 'M27.3417 77.5901H300.758V243.116L27.3417 77.5901Z',
  reelA: 'M109.367 193.975C128.997 193.975 144.911 178.922 144.911 160.353C144.911 141.784 128.997 126.73 109.367 126.73C89.7362 126.73 73.8225 141.784 73.8225 160.353C73.8225 178.922 89.7362 193.975 109.367 193.975Z',
  reelB: 'M218.733 193.975C238.364 193.975 254.278 178.922 254.278 160.353C254.278 141.784 238.364 126.73 218.733 126.73C199.103 126.73 183.189 141.784 183.189 160.353C183.189 178.922 199.103 193.975 218.733 193.975Z',
};

// Stroke widths from the export, in the 328-unit icon space.
export const ICON_STROKES = { body: 16.4, reel: 13.6667 };
